// extracted by mini-css-extract-plugin
export default {"checkbox__wrapper":"_5D3Ni-cl","checkbox__error":"_5DsL193B","checkbox__label":"_5D2D4C1s"};